module.exports = __webpack_public_path__ + "img/812_otto_e_mezzo_bombana.68927de0.jpg";